module.exports = __webpack_public_path__ + "static/media/ic_copy.a5543472.svg";